export default "__VITE_ASSET__ce0bda6b__"